import { Button, Flex, InfoBox } from "@jsq/ds/core";
import { SPACING } from "~/styles/variables";
import * as styles from "./styles_vanilla.css";

export type ExtractionErrorStateProps = {
  message: string;
  onRetry: () => void;
};

// FR-098: a failed job terminates the run and offers Retry, which reopens the modal.
export const ExtractionErrorState = ({ message, onRetry }: ExtractionErrorStateProps) => {
  return (
    <Flex
      flexDirection="column"
      alignItems="center"
      gap={SPACING.MEDIUM}
      className={styles.errorState}
      data-testid="ddq-structure-failed"
    >
      <InfoBox variant="error" title={message} />
      <Button onClick={onRetry} data-testid="ddq-structure-retry">
        Retry
      </Button>
    </Flex>
  );
};
